export default __webpack_public_path__ + "static/media/29t.fe954e0c.jpg";